import { chatIdentifierFromKey, chatIdentifierToKey, SafeMap, SafeSet, } from "@shared";
import {} from "./undo";
export class LocalSet {
    serialiser;
    deserialiser;
    #queue = [];
    constructor(serialiser, deserialiser) {
        this.serialiser = serialiser;
        this.deserialiser = deserialiser;
    }
    get added() {
        return new Set(this.#queue.filter((m) => m.kind === "add").map((m) => m.value));
    }
    get removed() {
        return new Set(this.#queue.filter((m) => m.kind === "remove").map((m) => m.value));
    }
    // only use for testing
    clear() {
        this.#queue = [];
    }
    add(thing) {
        const add = { kind: "add", value: thing };
        this.#queue.push(add);
        return () => {
            this.#queue = this.#queue.filter((m) => m !== add);
        };
    }
    remove(thing) {
        const remove = { kind: "remove", value: thing };
        this.#queue.push(remove);
        return () => {
            this.#queue = this.#queue.filter((m) => m !== remove);
        };
    }
    apply(original) {
        if (this.#queue.length === 0)
            return original;
        // only the last modification for each value has any effect
        const last = new SafeMap(this.serialiser, this.deserialiser);
        for (const mod of this.#queue) {
            last.set(mod.value, mod);
        }
        const merged = new SafeSet(this.serialiser, this.deserialiser);
        for (const v of original) {
            merged.add(v);
        }
        for (const [, mod] of last) {
            if (mod.kind === "remove") {
                merged.delete(mod.value);
            }
            if (mod.kind === "add") {
                merged.add(mod.value);
            }
        }
        return merged;
    }
}
export class ChatLocalSet extends LocalSet {
    constructor() {
        super((k) => chatIdentifierToKey(k), (k) => chatIdentifierFromKey(String(k)));
    }
}
